import React, { ReactNode } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Card } from '../atoms/Card';

interface AuthLayoutProps {
  children: ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { isDark } = useTheme();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Atroverse Trading</h1>
          <p className="text-gray-600 dark:text-gray-300">Practice trading without the risk</p>
        </div>
        <Card className="p-6">{children}</Card>
      </div>
    </div>
  );
};